import { render } from "./NCCC.vue?vue&type=template&id=7789aa31&scoped=true"
const script = {}

import "./NCCC.vue?vue&type=style&index=0&id=7789aa31&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7789aa31"

export default script